import * as React from 'react';
import { MultipleChoiceBesvarelse } from '../../models/MultipleChoiceBesvarelse';
import { Row, Col, Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { MultipleChoiceSvarmulighed } from '../../models/MultipleChoiceSvarmulighed';
import KonkurrenceDelopgaveSvarmulighed from '../konkurrence/KonkurrenceDelopgaveSvarmulighed';
import { MultipleChoiceSvar } from '../../models/MultipleChoiceSvar';
import { Section } from '../../uiComponents/layout/Section';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import RichTextEditor from '../../uiComponents/input/RichTextEditor';
import DraftHelper from '../../infrastructure/DraftHelper';
import { DelopgaveListItem } from '../../models/DelopgaveListItem';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { Jumbotron } from '../../uiComponents/Jumbotron';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { Modal } from '../../uiComponents/layout/Modal';
import { NumberFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError } from '../../infrastructure/ValidationResult';
import HelperMethods from '../../infrastructure/HelperMethods';
import { isNullOrUndefined } from '../../infrastructure/ValidationHelper';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';

export interface MultipleChoiceBesvarelsePresenterProps {
    multipleChoiceBesvarelse: MultipleChoiceBesvarelse;
    delopgave: DelopgaveListItem;
    isSaving: boolean;
    onMultipleChoiceSvarChanged: (spoergsmaalId: string, svarmulighedId: string) => void;
    onIndsendBesvarelse: () => void;
    onStartDelopgave: (varighed: number | undefined) => void;
    startDelopgaveErrorMessages: ValidationError[];
    konkurrenceId: string;
}

class MultipleChoiceBesvarelsePresenterState {
    varighed: number | undefined;
    sekunderTilbage: number | undefined;
    afslutningstidspunkt: Date | undefined;
}

export default class MultipleChoiceBesvarelsePresenter extends React.Component<MultipleChoiceBesvarelsePresenterProps, MultipleChoiceBesvarelsePresenterState> {
    constructor(props: MultipleChoiceBesvarelsePresenterProps) {
        super(props);

        this.state = {
            varighed: undefined,
            sekunderTilbage: undefined,
            afslutningstidspunkt: undefined
        };
        this.updateTidTilbage();

        this.getSvarmuligheder = this.getSvarmuligheder.bind(this);
        this.getSvar = this.getSvar.bind(this);
        this.onVarighedChanged = this.onVarighedChanged.bind(this);
        this.updateTidTilbage = this.updateTidTilbage.bind(this);
        this.getDelopgaveAfslutningstidspunkt = this.getDelopgaveAfslutningstidspunkt.bind(this);
    }

    componentDidUpdate(prevProps: MultipleChoiceBesvarelsePresenterProps, prevState: MultipleChoiceBesvarelsePresenterState) {
        if (this.skalDelopgaveStartes() && (this.state.afslutningstidspunkt === undefined || prevState.afslutningstidspunkt !== this.state.afslutningstidspunkt)) {
            this.updateTidTilbage();
        }
    }

    updateTidTilbage() {
        const self = this;
        if (this.skalDelopgaveStartes()) {
            setTimeout(function () {
                if (self.state.afslutningstidspunkt !== undefined) {
                    const afslutning = new Date(self.state.afslutningstidspunkt);
                    const sekunderTilAfslutning = Math.abs(HelperMethods.getSecondsTillDate(afslutning));
                    self.setState({
                        sekunderTilbage: sekunderTilAfslutning
                    });
                    self.updateTidTilbage();
                } else {
                    self.getDelopgaveAfslutningstidspunkt();
                }
            }, 1000);
        }
    }

    getDelopgaveAfslutningstidspunkt() {
        const delopgaveId = this.props.delopgave.id;
        if (delopgaveId !== undefined) {
            const apiCaller = createApiCaller();
            apiCaller.getDelopgaveAfslutningstidspunkt(this.props.konkurrenceId, delopgaveId).then(response => {                
                const nytAfslutningstidspunkt = isNullOrUndefined(response.afslutningstidspunkt) ? undefined : response.afslutningstidspunkt;
                this.setState({ afslutningstidspunkt: nytAfslutningstidspunkt });
            });
        }
    }

    getSvarmuligheder(svarmuligheder: MultipleChoiceSvarmulighed[], svar: MultipleChoiceSvar) {
        let eksisterendeSvar = '';
        if (svar !== undefined) {
            eksisterendeSvar = svar.svarmulighedId;
        }

        return svarmuligheder.map((svarmulighed, i) => {
            return (
                <KonkurrenceDelopgaveSvarmulighed
                    key={i}
                    svarmulighed={svarmulighed}
                    selected={eksisterendeSvar === svarmulighed.id}
                    onMultipleChoiceSvarChanged={this.props.onMultipleChoiceSvarChanged}
                    disabled={this.props.isSaving}
                    getDelopgaveAfslutningstidspunkt={this.getDelopgaveAfslutningstidspunkt}
                />
            );
        });
    }

    getSvar(spoergsmaalId: string) {
        return this.props.multipleChoiceBesvarelse.svarList.filter(s => s.spoergsmaalId === spoergsmaalId)[0];
    }

    getSpoergsmaalComponents() {
        if (this.skalDelopgaveStartes() && !this.erDelopgaveIgang()) {
            return;
        }
        return this.props.multipleChoiceBesvarelse.spoergsmaalList.map((spoergsmaal, i) =>
            (
                <Section>
                    <Row key={i}>
                        <Col md={3}>
                            <h4>{(i + 1)}/{this.props.multipleChoiceBesvarelse.antalSpoergsmaal}</h4>
                        </Col>
                        <Col md={7} className='delopgavespoergsmaal'>
                            <h4>{spoergsmaal.spoergsmaal}</h4>
                            <ul className='delopgavesvarmuligheder'>
                                {this.getSvarmuligheder(spoergsmaal.multipleChoiceSvarmuligheder, this.getSvar(spoergsmaal.id))}
                            </ul>

                        </Col>
                    </Row>
                </Section>
            )
        );
    }

    skalDelopgaveStartes(): boolean {
        return this.props.delopgave.skalStartesManuelt;
    }

    erDelopgaveIgang(): boolean {
        if (this.state.afslutningstidspunkt !== undefined) {
            return new Date(this.state.afslutningstidspunkt) > new Date();
        }
        return false;
    }

    getIndsendBesvarelsetekst() {
        let indsendBesvarelseTekst = 'Opgaven er først løst, når I har trykket på "Indsend besvarelse". Besvarelsen kan først indsendes, når alle spørgsmål er besvaret.';
        if (this.skalDelopgaveStartes()) {
            indsendBesvarelseTekst = 'Denne opgave er ikke igang og kan derfor ikke besvares.';
            if (this.erDelopgaveIgang() && this.state.sekunderTilbage !== undefined) {
                const sekunder = Math.trunc((this.state.sekunderTilbage) % 60);
                const minutter = Math.trunc((this.state.sekunderTilbage / 60) % 60);
                indsendBesvarelseTekst = `Opgaven afsluttes, og besvarelsen indsendes, automatisk når tiden løber ud om: ${minutter} minutter og ${sekunder} sekunder`;
            }
        }

        return indsendBesvarelseTekst;
    }

    getIndsendBesvarelsesSection() {
        return (
            <div>
                <Jumbotron
                    title='Besvarelse'
                    message={this.getIndsendBesvarelsetekst()}
                    icon='warning'
                >
                    {
                        this.skalDelopgaveStartes() && getLoggedInBruger().rolle === BrugerRolleEnum.Administrator &&
                        <div className='start-delopgave-button-section'>
                            <Button buttonType='secondary' dataToggle='modal' dataTarget='#startDelopgaveModal'>Set delopgave timer</Button>
                        </div>
                    }
                </Jumbotron>
            </div>
        );
    }

    getStartDelopgaveModal() {
        return (
            <Modal className='startDelopgaveModal' id='startDelopgaveModal' excludeCancel={true} alert={true} text='Hvor mange minutter skal delopgaven være aktiv i?'>
                <NumberFormGroup
                    errorMessages={this.props.startDelopgaveErrorMessages}
                    label=''
                    name='afslutningstidspunkt'
                    placeholder='Angiv antal minutter'
                    value={this.state.varighed}
                    onChange={this.onVarighedChanged}
                />
                <Button buttonType='primary' onClick={c => this.props.onStartDelopgave(this.state.varighed)}>Start delopgave</Button>
                <Button buttonType='secondary' onClick={() => this.getDelopgaveAfslutningstidspunkt()}>Vis timer</Button>
            </Modal>
        );
    }

    onVarighedChanged(fieldName: string, value: any) {
        let varighed = Number(value);
        if (!isNaN(varighed) && varighed % 1 === 0) {
            this.setState({ varighed: varighed });
        }
    }

    render() {
        return (
            <SectionGroup>
                <Section>
                    <Row>
                        <Col md={7} mdOffset={3}>
                            {this.getIndsendBesvarelsesSection()}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={7} mdOffset={3}>
                            <p>
                                <RichTextEditor readOnly={true} editorState={DraftHelper.getContentAsEditorState(this.props.delopgave.indhold)} />
                            </p>
                        </Col>
                    </Row>
                </Section>
                <div>
                    {this.getSpoergsmaalComponents()}
                    {this.props.multipleChoiceBesvarelse.alleSpoergsmaalBesvaret && !this.skalDelopgaveStartes() &&
                        <ButtonSection>
                            <Button
                                buttonType='primary'
                                disabled={this.props.isSaving}
                                onClick={this.props.onIndsendBesvarelse}
                            >
                                Indsend besvarelse
                            </Button>
                        </ButtonSection>
                    }
                </div>
                {this.getStartDelopgaveModal()}
            </SectionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgaveBedoemmelse/MultipleChoiceBesvarelsePresenter.tsx